import { useTranslation } from "react-i18next";
import lookupTables from "../../data/lookup_tables.json";
import CompareStripedRows from "./CompareStripedRows";
import { V1Clinic } from "../../types/v1_schemas";

function FeesTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  const rowData = 
  lookupTables.paymentTypes.sort((s1, s2) => s1.description > s2.description ? 1 : -1).filter(f => f.text !== "Unknown").map((m : any) => {
    return {
      label: t(`${m.translate}`),
      compareA: !!providerA.clinicPaymentOptions?.filter(f => f.lineageText === t(m.lineageText))[0],
      compareB: !!providerB.clinicPaymentOptions?.filter(f => f.lineageText === t(m.lineageText))[0]
    };
  });

  return <CompareStripedRows rows={rowData} title={t("feesTitle")} />;
}

export default FeesTable;
